import _styled from "@emotion/styled/base";
export const ContentWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efblbys0"
} : {
  target: "efblbys0",
  label: "ContentWrapper"
})("svg{fill:", _ref => {
  let {
    colours: {
      backgroundColour
    }
  } = _ref;
  return backgroundColour;
}, ";path.background{stroke:", _ref2 => {
  let {
    colours: {
      backgroundStrokeColour
    }
  } = _ref2;
  return backgroundStrokeColour;
}, ";}path.logo{fill:", _ref3 => {
  let {
    colours: {
      logoColour
    }
  } = _ref3;
  return logoColour;
}, ";}&:hover{cursor:pointer;fill:", _ref4 => {
  let {
    hoverColours: {
      backgroundColour
    }
  } = _ref4;
  return backgroundColour;
}, ";path.background{stroke:", _ref5 => {
  let {
    hoverColours: {
      backgroundStrokeColour
    }
  } = _ref5;
  return backgroundStrokeColour;
}, ";}path.logo{fill:", _ref6 => {
  let {
    hoverColours: {
      logoColour
    }
  } = _ref6;
  return logoColour;
}, ";}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9BdG9tcy9Tb2NpYWxJY29ucy9Tb2NpYWxJY29ucy5zdHlsZXMuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV3QyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvQXRvbXMvU29jaWFsSWNvbnMvU29jaWFsSWNvbnMuc3R5bGVzLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuZXhwb3J0IGNvbnN0IENvbnRlbnRXcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgc3ZnIHtcbiAgICBmaWxsOiAkeyh7IGNvbG91cnM6IHsgYmFja2dyb3VuZENvbG91ciB9IH0pID0+IGJhY2tncm91bmRDb2xvdXJ9O1xuXG4gICAgcGF0aC5iYWNrZ3JvdW5kIHtcbiAgICAgIHN0cm9rZTogJHsoeyBjb2xvdXJzOiB7IGJhY2tncm91bmRTdHJva2VDb2xvdXIgfSB9KSA9PiBiYWNrZ3JvdW5kU3Ryb2tlQ29sb3VyfTtcbiAgICB9XG5cbiAgICBwYXRoLmxvZ28ge1xuICAgICAgZmlsbDogJHsoeyBjb2xvdXJzOiB7ICBsb2dvQ29sb3VyIH0gfSkgPT4gbG9nb0NvbG91cn07XG4gICAgfVxuXG4gICAgJjpob3ZlciB7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgICBmaWxsOiAkeyh7IGhvdmVyQ29sb3VyczogeyBiYWNrZ3JvdW5kQ29sb3VyIH0gfSkgPT4gYmFja2dyb3VuZENvbG91cn07XG5cbiAgICAgIHBhdGguYmFja2dyb3VuZCB7XG4gICAgICAgIHN0cm9rZTogJHsoeyBob3ZlckNvbG91cnM6IHsgYmFja2dyb3VuZFN0cm9rZUNvbG91ciB9IH0pID0+IGJhY2tncm91bmRTdHJva2VDb2xvdXJ9O1xuICAgICAgfVxuXG4gICAgICBwYXRoLmxvZ28ge1xuICAgICAgICBmaWxsOiAkeyh7IGhvdmVyQ29sb3VyczogeyAgbG9nb0NvbG91ciB9IH0pID0+IGxvZ29Db2xvdXJ9O1xuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ== */"));